// 斯洛文尼亚语
import slLocale from 'element-ui/lib/locale/lang/sl'


const sl = {
  // ============= 登录 start ============
  "验证码": "Preverjanje kode",
  "登录": "Prijava",
  "请输入验证码": "Prosim vnesite preverjanje kode",
  "验证码不正确!": "Napačna preverjanje koda!",
  "请输入账号": "Prosim vnesite svoj račun",
  "请输入密码": "Prosim vnesite geslo",
  "访问地址有误，请在shop后台核实": "Dostopni naslov je napačen, prosim preverite v trgovini backend",
  // ============= 登录 end ============

  // ============= Layout start ============
  "全屏模式": "Polnozaslonski način",
  "首页": "Domov",
  "此操作将退出登录, 是否继续?": "Ta operacija bo odjavila, želite nadaljevati?",
  "已取消退出": "Odjava preklicana",
  "您有一个新订单": "Imate novo naročilo",
  "无法获取当前门店信息，请重新登录": "Trenutnih informacij o trgovini ni mogoče pridobiti, prosim ponovno se prijavite",
  "收银台": "Blagajna",
  "收银": "Blagajna",
  "桌台": "Miza",
  "订单": "Naročilo",
  // ============= Layout end ============

  // ============= 首页 start ============
  "查询会员": "Iskanje članov",
  "商品改价": "Spremeni ceno",
  "商品删行": "Izbriši postavko",
  "整单取消": "Prekliči naročilo",
  "挂单": "Ohrani naročilo",
  "折扣": "Popust",
  "抹零": "Zaokroži",
  "请输入内容": "Prosim vnesite vsebino",
  "收银员": "Blagajnik",
  "店内就餐": "Jedi v restavraciji",
  "打包带走": "S seboj",
  "商品名称": "Ime izdelka",
  "商品价格": "Cena izdelka",
  "商品数量": "Količina izdelka",
  "应收": "Skupaj plačilo",
  "包装费": "Strošek pakiranja",
  "优惠": "Popust",
  "数量": "Količina",
  "件": "Kos",
  "实收": "Prejeti znesek",
  "收款": "Prejemanje plačila",
  "请选择商品": "Prosim izberite izdelke",
  "确定要删除": "Ste prepričani, da želite izbrisati",
  "提示": "Namig",
  "确定": "Potrdi",
  "取消": "Prekliči",
  "请先将购物车内的商品挂单或结账后再取单": "Pred prevzemom naročila prosim obdržite ali plačajte izdelke v nakupovalnem vozičku",
  "确定要整单取消吗?": "Ste prepričani, da želite preklicati naročilo?",
  "请输入会员手机号查询会员，输入完毕后点击确认": "Prosim vnesite telefonsko številko člana za iskanje, nato kliknite, da potrdite",
  "请输入会员手机号": "Prosim vnesite telefonsko številko člana",
  "会员昵称": "Vzdevek člana",
  "余额总计": "Skupno stanje",
  "退出": "Izhod",
  "该用户不存在": "Ta uporabnik ne obstaja",
  "折扣抹零": "Popust / Zaokroži",
  "当前价格": "Trenutna cena",
  "改价": "Spremeni ceno",
  "实付价格": "Dejanska cena",
  "请输入实付价格": "Prosim vnesite dejansko ceno",
  "优惠折扣": "Stopnja popusta",
  "请输入优惠折扣": "Prosim vnesite stopnjo popusta",
  "抹分": "Zaokroži na desetinke",
  "抹角": "Zaokroži na dolare",
  "四舍五入到角": "Zaokroži na najbližjo desetinko",
  "四舍五入到元": "Zaokroži na najbližji dolar",
  "确 定": "Potrdi",
  "价格不能为空": "Cena ne sme biti prazna",
  "折扣不能为空": "Popust ne sme biti prazen",
  "修改价格": "Spremeni ceno",
  "本次售价": "Trenutna prodajna cena",
  "请输入本次售价": "Prosim vnesite trenutno prodajno ceno",
  "清空": "Počisti",
  "确认": "Potrdi",
  "商品详情": "Podrobnosti o izdelku",
  "单位": "Enota",
  "规格": "Specifikacije",
  "加料": "Dodatne sestavine",
  "取 消": "Prekliči",
  "现金收款": "Gotovinsko plačilo",
  "余额收款": "Plačilo z bilanco",
  "其他方式": "Druge metode",
  "应收金额": "Skupni znesek",
  "用户通过店内扫码等方式进行支付，确认用户支付成功后，点击确认付款即可完成付款操作。": "Kupci lahko plačajo s pomočjo QR kode v trgovini in drugimi metodami. Po potrditvi uspešnega plačila kliknite 'Potrdi plačilo', da zaključite transakcijo.",
  "微信支付": "WeChat Plačilo",
  "支付宝支付": "Alipay Plačilo",
  "pos刷卡": "POS Kartično plačilo",
  "请输入会员ID号查询会员，输入完毕后点击确认": "Prosim vnesite ID člana za iskanje člana, nato kliknite, da potrdite",
  "请输入会员ID": "Prosim vnesite ID člana",
  "登录会员仅作为积分累计，无法享受其他优惠。": "Prijavljeni člani lahko kopičijo samo točke in niso upravičeni do drugih popustov.",
  "取消收款": "Prekliči plačilo",
  "订单总价": "Skupna cena naročila",
  "挂单时间": "Čas hrambe naročila",
  "删除": "Izbriši",
  "取单": "Pridobi naročilo",
  "多语言小票打印": "Tiskanje računa v več jezikih",
  "打印语言": "Jezik tiskanja",
  "中文": "Kitajski",
  "英语": "Angleščina",
  "德语": "Nemščina",
  "法语": "Francoščina",
  "西班牙语": "Španščina",
  "意大利语": "Italijanščina",
  "克罗地亚": "Hrvaščina",
  "斯洛文尼亚": "Slovenščina",
  "匈牙利语": "Madžarščina",
  "塞尔维亚语": "Srbščina",
  // ============= 首页 end   ============

  // ============= 桌台 start ============
  "未开台": "Ni odprto",
  "已开台": "Odprta miza",
  "就餐中": "Jed",
  "刷新": "Osveži",
  "整单清空": "Počisti celotno naročilo",
  "转台": "Spremeni mizo",
  "打印预结单": "Natisni predhodni račun",
  "催菜": "Pospeši naročilo",
  "人数": "Število gostov",
  "订单来源": "Vir naročila",
  "请点击左侧桌号台": "Prosim kliknite na številko mize na levi strani",
  "点选已开台桌台，可以在此查看点餐信息。": "Izberite odprto mizo, da si ogledate podrobnosti naročila tukaj.",
  "服务费": "Strošek storitev",
  "税费": "Davek",
  "协助点餐": "Pomoč pri naročanju",
  "协助加餐": "Pomoč pri dodajanju izdelkov",
  "结账": "Konec",
  "完成": "Končano",
  "价格": "Cena",
  "请选择": "Prosim izberite",
  "确定要打印小票吗?": "Ste prepričani, da želite natisniti račun?",
  "确定要关闭桌台并取消订单吗?": "Ste prepričani, da želite zapreti mizo in preklicati naročilo?",
  "请选择桌号": "Prosim izberite številko mize",
  "就餐人数": "Število gostov",
  "下单": "Naroči",
  "返回": "Nazaj",
  "确定要商品删行吗?": "Ste prepričani, da želite izbrisati postavko?",
  "请选择就餐人数": "Prosim izberite število gostov",
  // ============= 桌台 end ============

  // ============= 订单 start ============
  "下单时间": "Čas naročanja",
  "起始时间": "Začetni čas",
  "店内订单": "Naročilo v trgovini",
  "自提订单": "Naročilo za prevzem",
  "外卖订单": "Naročilo za dostavo",
  "名称": "Ime",
  "支付时间": "Čas plačila",
  "消费方式": "Način plačila",
  "状态": "Status",
  "单价": "Enotna cena",
  "金额": "Znesek",
  "税率": "Davčna stopnja",
  "税费金额": "Znesek davka",
  "邮箱地址": "E-poštni naslov",
  "今天": "Danes",
  "昨天": "Včeraj",
  "一周": "En teden",
  "搜索": "Iskanje",
  "待完成": "Čakajoče",
  "已完成": "Končano",
  "已取消": "Preklicano",
  "全部": "Vse",
  "顾客信息": "Informacije o stranki",
  "用户昵称": "Uporabniško ime",
  "手机号": "Telefonska številka",
  "收货地址": "Naslov dostave",
  "取单号": "Številka prevzema naročila",
  "就餐方式": "Način jedi",
  "订单号": "Številka naročila",
  "订单金额": "Znesek naročila",
  "订单优惠": "Popust na naročilo",
  "实付金额": "Dejanski znesek plačila",
  "支付方式": "Način plačila",
  "备注信息": "Opombe",
  "期望配送时间": "Pričakovani čas dostave",
  "取餐时间": "Čas prevzema",
  "配送费": "Strošek dostave",
  "退款金额": "Znesek vračila",
  "准备中": "Priprava",
  "出餐中": "Priprava jedi",
  "待取餐": "Čakam na prevzem",
  "订单信息": "Informacije o naročilu",
  "税费详情": "Podrobnosti o davku",
  "取消订单": "Prekliči naročilo",
  "打印小票": "Natisni račun",
  "出餐": "Postrežba jedi",
  "确认送达": "Potrdi dostavo",
  "退款": "Vračilo",
  "已退款": "Vračilo izvršeno",
  "请输入订单号": "Prosim vnesite številko naročila",
  "至": "Do",
  "开始日期": "Začetni datum",
  "结束日期": "Končni datum",
  "发送账单": "Pošlji račun",
  "请输入邮箱地址": "Prosim vnesite svoj e-poštni naslov",
  "确定要催菜吗?": "Ste prepričani, da želite pospešiti naročilo?",
  "确定要完成订单吗?": "Ste prepričani, da želite zaključiti naročilo?",
  "确定要出餐吗?": "Ste prepričani, da želite postreči jedi?",
  "确定要发送账单吗?": "Ste prepričani, da želite poslati račun?",
  "邮箱不能为空": "E-pošta ne sme biti prazna",
  "确定要取消订单吗?": "Ste prepričani, da želite preklicati naročilo?",
  "是否确认此操作?": "Ste prepričani, da želite potrditi to operacijo?",
  "上传文件只能是excel格式!": "Naložena datoteka mora biti v formatu Excel!",
  "上传文件大小不能超过 10MB!": "Velikost naložene datoteke ne sme presegati 10 MB!",
  "正在处理,请等待": "Obdelava poteka, prosim počakajte",
  "本次处理失败": "Obdelava ni uspela tokrat",
  "总金额": "Skupni znesek",
  "可退款金额": "Znesek vračila",
  "请输入退款金额": "Prosim vnesite znesek vračila",
  "超出可退款金额": "Presega znesek vračila",
  "404错误页面": "Stranica napake 404",
  "合计": "Skupaj",
  "份": "Del",
  "余额支付": "Plačilo Stanja",
  "线下支付(现金支付)": "Plačilo V Odsotnosti (Gotovinsko Plačilo)",
  "线下支付(微信支付)": "Plačilo V Odsotnosti (Lastno Plačilo WeChata)",
  "线下支付(支付宝支付)": "Plačilo V Odsotnosti (Lastno Plačilo Alipay-a)",
  "线下支付(POS刷卡支付)": "Plačilo V Odsotnosti (Plačilo s POS Kartico)",
  "进行中": "V Izvedbi",
  "待付款": "Čakajoče Plačilo",
  "待配送": "Čakajoče na Dostavo",
  "配送中": "V Dostavi",
  "待接单": "Čakajoče na Sprejem",
  "待取货": "Čakajoče na Prevzem",
  "已配送": "Dostavljeno",
  "已收货": "Prejeto",
  "待收货": "Čakajoče na Prevzem",
  "待取消": "Čakajoče na Preklic",
  "会员": "Član",
  "商家": "Trgovec",
  "供应商": "Dobavitelj",
  "分销": "Distribucija",
  "通知": "Obvestilo",
  "已付款": "Plačano",
  "用户下单": "Naročilo Uporabnika",
  "收银台下单": "Naročilo na Blagajni",
  "扫码下单": "Naročilo s Skeniranjem",
  "团购下单": "Skupinsko Naročilo",
  "商城订单": "Naročilo Trgovine",
  "积分商城订单": "Naročilo Trgovine S Točkami",
  "余额充值订单": "Naročilo Polnjenja Stanja",
  "购卡订单": "Naročilo Nakupa Kartice",
  "券包订单": "Naročilo Paketa Kuponov",
  "配送员押金订单": "Naročilo Depozita Dostavljavca",
  "团购订单": "Skupinsko Naročilo",
  "下单减库存": "Zmanjšanje Zaloge ob Naročilu",
  "付款减库存": "Zmanjšanje Zaloge ob Plačilu",
  "商家配送": "Dostava s Trgovcem",
  "外卖配送": "Dostava na Doma",
  "到店自提": "Osebni Prevzem",
  "快递配送": "Hitra Pošiljka",
  "个人中心": "Osebni Center",
  ...slLocale
}


export default sl



// WEBPACK FOOTER //
// ./src/i18n/langs/sl.js